"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSlider = useSlider;
var _react = require("react");
var _reactSwipeable = require("react-swipeable");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function useSlider(_ref) {
  var numSlides = _ref.numSlides,
    _ref$infinite = _ref.infinite,
    isInfinite = _ref$infinite === void 0 ? false : _ref$infinite,
    _ref$afterPositionCha = _ref.afterPositionChange,
    afterPositionChange = _ref$afterPositionCha === void 0 ? function () {} : _ref$afterPositionCha;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  var lastPositon = (0, _react.useRef)(position);
  var lastSlideIndex = numSlides - 1;
  (0, _react.useEffect)(function () {
    lastPositon.current = position;
  }, [position]);
  var setPositionAndCallback = (0, _react.useCallback)(function (_ref2) {
    var direction = _ref2.direction,
      newPosition = _ref2.newPosition;
    setPosition(newPosition);
    afterPositionChange({
      direction: direction,
      index: newPosition
    });
  }, [afterPositionChange]);
  var nextSlide = (0, _react.useCallback)(function () {
    var isLastSlide = position === lastSlideIndex;
    var direction = 'next';
    if (isLastSlide) {
      if (isInfinite) {
        setPositionAndCallback({
          direction: direction,
          newPosition: 0
        });
      }
      return;
    }
    setPositionAndCallback({
      direction: direction,
      newPosition: lastPositon.current + 1
    });
  }, [position, isInfinite, lastSlideIndex, setPositionAndCallback]);
  var prevSlide = (0, _react.useCallback)(function () {
    var isFirstSlide = position === 0;
    var direction = 'prev';
    if (isFirstSlide) {
      if (isInfinite) {
        setPositionAndCallback({
          direction: direction,
          newPosition: lastSlideIndex
        });
      }
      return;
    }
    setPositionAndCallback({
      direction: direction,
      newPosition: lastPositon.current - 1
    });
  }, [position, isInfinite, lastSlideIndex, setPositionAndCallback]);
  var swipeHandlers = (0, _reactSwipeable.useSwipeable)({
    onSwipedLeft: nextSlide,
    onSwipedRight: prevSlide,
    preventDefaultTouchmoveEvent: true
  });
  return {
    position: position,
    setPosition: setPosition,
    nextSlide: nextSlide,
    prevSlide: prevSlide,
    swipeHandlers: swipeHandlers
  };
}
useSlider.propTypes = {
  numSlides: _propTypes["default"].number.isRequired,
  hideFirstLastArrow: _propTypes["default"].bool,
  infinite: _propTypes["default"].bool,
  afterPositionChange: _propTypes["default"].func
};